import AutocompleteInput, { Option } from '@/components/inputs/AutocompleteInput';
import { useState, useMemo } from 'react';

interface TransitionSelectorProps {
  transition: Option | null;
  setTransition: (option: Option | null) => void;
  transitionOptions: Option[];
  isTransitionsLoading: boolean;
  disabled: boolean;
}

const TransitionSelector = ({
  transition,
  setTransition,
  transitionOptions,
  isTransitionsLoading,
  disabled,
}: TransitionSelectorProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredOptions = useMemo(() => {
    if (!searchQuery.trim()) return transitionOptions;
    const query = searchQuery.toLowerCase();
    return transitionOptions.filter((opt) =>
      opt.label.toLowerCase().includes(query)
    );
  }, [transitionOptions, searchQuery]);

  return (
    <div className='flex flex-col gap-2 text-base'>
      <label className='text-[13px] font-bold text-gray-400 uppercase tracking-widest px-1'>
        SELECCIONA CHECKPOINT
      </label>
      <AutocompleteInput
        name='batch-checkpoint-transition'
        placeholder={disabled ? 'Bloqueado durante el escaneo' : 'Buscar checkpoint...'}
        value={transition}
        onChange={setTransition}
        onInputChange={setSearchQuery}
        options={filteredOptions}
        loading={isTransitionsLoading}
        disabled={disabled}
        showTypingLengthHint={false}
      />
    </div>
  );
};

export default TransitionSelector;
